
const productSection = document.querySelector('.product');

let variantSelects = productSection.querySelector('variant-selects');
let variantSelectsItems = variantSelects?.querySelectorAll('.product-form__input label');

//const productGifts = productSection.querySelector('.product-gifts');
//const productGiftsItem = productGifts.querySelectorAll('.item');

let productGiftsUnlocked = {'items':[{id:productVariantId, quantity:1}]};

function productDirectCheckout(){
    
    if(productGiftsUnlocked.items.length != 0){
        url = `https://sereaum.myshopify.com/cart/`;
        productGiftsUnlocked.items.forEach((item, index) => {
            url += `${item.id}:${item.quantity}`;
            if (index < productGiftsUnlocked.items.length - 1) {
                url += ',';
            }
        })
        window.location.href = url;
    }
}
/*
function updateProductGifts(step, variantId){

    productGiftsUnlocked = {'items':[]};

    for(let i=0;i<productGiftsItem.length;i++){

        const productGiftsUnlockedItems = productGiftsUnlocked.items;

        if(productGiftsItem[i].id <= step){

            // AJUST ITEM DESIGN
            productGiftsItem[i].removeAttribute('locked');

            // ADD PRODUCT

            let mainProductExist = false;

            for(let y=0;y<productGiftsUnlockedItems.length;y++){
                if(productGiftsUnlockedItems[y].id == variantId){
                    mainProductExist = true
                }else{
                }
            }

            if(mainProductExist == false){
                let productVariantInfo = {id: variantId, quantity: 1}
                productGiftsUnlocked['items'].push(productVariantInfo);
            }

            // ADD GIFTS
            const giftInput = productGiftsItem[i].querySelector('input');
            if(giftInput.id != ''){

                const productGiftsUnlockedItems = productGiftsUnlocked.items;

                if(productGiftsUnlockedItems!=0){

                    let productGiftsExist = false;
                    let productGiftsExistId;

                    for(let y=0;y<productGiftsUnlockedItems.length;y++){
                        if(productGiftsUnlockedItems[y].id == giftInput.id){
                            productGiftsExist = true
                            productGiftsExistId = y;
                        }
                    }

                    if(productGiftsExist == false){
                        let productInfo = {id: giftInput.id, quantity: 1}
                        productGiftsUnlocked['items'].push(productInfo);
                    }else{
                        productGiftsUnlockedItems[productGiftsExistId].quantity++;
                    }

                }else{
                    let productInfo = {id: giftInput.id, quantity: 1}
                    productGiftsUnlocked['items'].push(productInfo);
                }
            }

        }else{
            productGiftsItem[i].setAttribute('locked', '');
        }
    }
}
*/

function updateVariantSelected(variantId){
    productGiftsUnlocked = {'items':[{id:variantId, quantity:1}]};
}

function updateVariantSelects(){

    // UPDATE ELEMENTS
    variantSelects = productSection.querySelector('variant-selects');
    variantSelectsItems = variantSelects?.querySelectorAll('.product-form__input label');

    // EVENTS
    variantSelectsItems?.forEach(item => {
        item.addEventListener('click', () => {
            //updateProductGifts(item.id, item.dataset.variantId);
            updateVariantSelected(item.dataset.variantId);
        })
    })

}
setInterval(updateVariantSelects, 500);

// INIT FIRST VARIANT
if (variantSelectsItems) {
  variantSelectsItems[0].click();
}